import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import AmazonConnect from '@stubhub/react-amazon-connect';
import VoiceFlow from '@stubhub/react-voice-flow';

export const VIRTUAL_ASSISTANT_TYPE = {
  AMAZON_CONNECT: 'AMAZON_CONNECT',
  VOICE_FLOW: 'VOICE_FLOW',
  NONE: 'NONE',
};

const virtualAssistantTypeValues = Object.values(VIRTUAL_ASSISTANT_TYPE);

const VIRTUAL_ASSISTANT_COMPONENT = {
  [VIRTUAL_ASSISTANT_TYPE.AMAZON_CONNECT]: AmazonConnect,
  [VIRTUAL_ASSISTANT_TYPE.VOICE_FLOW]: VoiceFlow,
  [VIRTUAL_ASSISTANT_TYPE.NONE]: () => null,
};

const VirtualAssistant = ({className, type = VIRTUAL_ASSISTANT_TYPE.AMAZON_CONNECT, ...otherProps}) => {
  const Component = VIRTUAL_ASSISTANT_COMPONENT[type];

  return (
    <div className={cx('virtual-assistant', className)}>
      <Component {...otherProps} />
    </div>
  );
};

VirtualAssistant.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(virtualAssistantTypeValues),
};

export default VirtualAssistant;
